<template>
  <div class="form-box">
    <h2>Reset your password</h2>

    <p>Please choose a new password that contains the following:</p>
    <ul class="mb-8">
      <li>At least 8 characters.</li>
      <li>A mixture of both uppercase and lowercase letters.</li>
      <li>At least one number.</li>
      <li>At least one special character, e.g., ! @ # ? ] (but not &lt; or &gt;).</li>
    </ul>

    <v-form class="form" ref="form" @submit.prevent="resetPassword()">
      <v-container class="pa-0">
        <v-row>
          <v-col
            cols="12"
          >
            <label>New password</label>
            <v-text-field
              v-model="password"
              placeholder="Enter new password"
              required
              outlined
              class="text-field-outlined-overrides"
              :rules="validation.password"
              :append-icon="passwordVisible ? 'mdi-eye' : 'mdi-eye-off'"
              :type="passwordVisible ? 'text' : 'password'"
              @click:append="passwordVisible = !passwordVisible"
              persistent-hint
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col
            cols="12"
            class="pt-0"
          >
            <v-btn
              type="submit"
              class="primary mb-4"
              width="100%"
              height="48"
            >Reset password</v-btn>

            <router-link :to="{name: 'Login'}">
              <v-btn
                text
                color="primary"
                width="100%"
                height="48"
              >Return to sign in</v-btn>
            </router-link>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import config from '../config';
import util from '../util';

export default {
  name: 'ResetPassword',
  data: () => {
    return {
      password: null,
      passwordVisible: false,
      validation: config.formValidations,
    };
  },
  methods: {
    resetPassword: async function () {
      const isValid = this.$refs.form.validate();
      if (!isValid) {
        return;
      }

      const userID = this.$store.state.userID;
      const formData = new FormData();
      formData.append('password', this.password);

      const options = {
        method: 'PUT',
        body: formData,
        ...config.defaultFetchOptions,
      };
      const result = await fetch(`${this.$store.state.apiHost}/users/${userID}/password`, options);

      if (result.ok) {
        util.deleteLocalStorage(this.$store);
        this.$store.commit('snackbar', {text: 'Password reset.  Please login.', color: 'success'});
        this.$router.push(({name: 'Login'}));
      } else {
        this.$store.commit('snackbar', {text: 'Failed to reset password.', color: 'error'});
      }
    },
  },
}
</script>